export { default as QuickBookingSlot } from './QuickBookingSlot'
export { default as QuickBookingSlotSkeleton } from './Skeleton'
